import { Badge } from '@ovComponents/2-component/badge/badge';
import type { OptimizerAuditRollup } from '@ovComponents/4-module/bulkRebalance/types/audit.types';
import type { BulkRebalanceRun } from '@ovComponents/4-module/bulkRebalance/types/run.types';
import { getRunStateBadgeColor } from '@ovComponents/4-module/bulkRebalance/utils/presentation/runStateBadge';
import { Box, Typography } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { BulkRebalanceRunOutcomeStrip } from './runOutcomeStrip';

export type BulkRebalanceRunHeaderProps = {
  run: BulkRebalanceRun;
  inProgress: boolean;
  auditRollup?: OptimizerAuditRollup | null;
};

export const BulkRebalanceRunHeader = ({
  run,
  inProgress,
  auditRollup = null,
}: BulkRebalanceRunHeaderProps) => {
  const { t } = useTranslation(['bulkRebalance']);

  return (
    <Box
      data-testid='bulk-rebalance-run-header'
      sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
    >
      <Box
        sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}
      >
        <Badge label={t(`runType.${run.type}`)} color='supportOne' />
        <Badge
          label={t(`runState.${run.state}`)}
          color={getRunStateBadgeColor(run.state)}
          testId='bulk-rebalance-run-state-badge'
        />
      </Box>

      {!inProgress && (
        <BulkRebalanceRunOutcomeStrip run={run} auditRollup={auditRollup} />
      )}

      {run.errorMessage && (
        <Typography
          variant='bodyMedium'
          color='error'
          data-testid='bulk-rebalance-run-error'
        >
          {run.errorMessage}
        </Typography>
      )}
    </Box>
  );
};
